// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/farms/';
export const actions = [
  'SET_ALL_FARMS'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer(
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_ALL_FARMS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}

// Action Creators

export const setAllFarms = (farms) => {
  return {
    type: actions.SET_ALL_FARMS,
    payload: farms
  };
};
